import React, { useState } from 'react';
import { Input, Label } from 'reactstrap';

export default function OrderHookFilter({ value = {}, onChange, disabled }) {
  const [field, setField] = useState('salesChannel');
  const [rule, setRule] = useState('in');
  const [newId, setNewId] = useState('');

  // Convert all snake_case keys to camelCase for consistent handling
  const normalizedValue = {};
  Object.keys(value).forEach(key => {
    const camelKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
    normalizedValue[camelKey] = value[key];
  });

  const filters = normalizedValue[field] || [];

  const handleAddFilter = () => {
    if (!newId.trim()) return;

    const existingFilterIndex = filters.findIndex((f) => f[rule]);
    const newFilters = [...filters];

    if (existingFilterIndex >= 0) {
      const existingRule = newFilters[existingFilterIndex][rule];
      if (!existingRule.includes(newId)) {
        newFilters[existingFilterIndex] = {
          ...newFilters[existingFilterIndex],
          [rule]: [...existingRule, newId],
        };
      }
    } else {
      newFilters.push({ [rule]: [newId] });
    }

    // Always use camelCase for the field key when saving
    onChange({
      ...normalizedValue,
      [field]: newFilters,
    });

    setNewId('');
  };

  const handleRemoveId = (ruleType, id) => {
    const newFilters = filters.map((filter) => {
      if (filter[ruleType]) {
        const updatedRule = filter[ruleType].filter((i) => i !== id);
        return {
          ...filter,
          [ruleType]: updatedRule,
        };
      }
      return filter;
    });

    // Always use camelCase for the field key when saving
    onChange({
      ...normalizedValue,
      [field]: newFilters,
    });
  };

  const handleAddNewRule = () => {
    if (filters.some((f) => f[rule])) return;

    // Always use camelCase for the field key when saving
    onChange({
      ...value,
      [field]: [...filters, { [rule]: [] }],
    });
  };

  const getFieldDisplayName = () => {
    switch (field) {
      case 'salesChannel':
        return 'Sales Channel Id';
      default:
        return field;
    }
  };

  const getRuleDisplayName = (ruleType) => {
    switch (ruleType) {
      case 'in':
        return 'é';
      case 'not_in':
        return 'não é';
      default:
        return ruleType;
    }
  };

  // Flatten all rules from all filters
  const allRules = filters.flatMap((filter) =>
    Object.keys(filter).map((ruleType) => ({
      ruleType,
      ids: filter[ruleType] || [],
    })),
  );

  return (
    <div className="mt-3">
      <Label className="form-label fw-semibold mb-2">
        Filtro do Order Hook
      </Label>
      <p className="text-muted mb-3">
        Filtre o envio de pedidos por campos e valores da Vtex
      </p>

      <div className="d-flex align-items-center gap-2 mb-3">
        <div className="d-flex align-items-center gap-2">
          <Label className="mb-0">Campo:</Label>
          <Input
            type="select"
            value={field}
            onChange={(e) => setField(e.target.value)}
            disabled={disabled}
            style={{ width: '150px' }}
          >
            <option value="salesChannel">Sales Channel</option>
          </Input>
        </div>

        <div className="d-flex align-items-center gap-2">
          <Label className="mb-0"></Label>
          <Input
            type="select"
            value={rule}
            onChange={(e) => setRule(e.target.value)}
            disabled={disabled}
            style={{ width: '100px' }}
          >
            <option value="in">É</option>
            <option value="not_in">Não é</option>
          </Input>
        </div>

        <button
          type="button"
          className="btn btn-sm btn-light"
          onClick={handleAddNewRule}
          disabled={disabled || filters.some((f) => f[rule])}
        >
          +
        </button>
      </div>

      {/* Show all rules */}
      {allRules.map(({ ruleType, ids }, index) => (
        <div key={`${ruleType}-${index}`} className="mb-3">
          <div className="d-flex align-items-center gap-2 mb-2">
            <strong>
              {getFieldDisplayName()} {getRuleDisplayName(ruleType)}:
            </strong>
            <div className="d-flex align-items-center gap-2">
              <Input
                type="text"
                value={ruleType === rule ? newId : ''}
                onChange={(e) => setNewId(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleAddFilter()}
                disabled={disabled || ruleType !== rule}
                placeholder="ID"
                style={{ width: '100px' }}
              />
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={handleAddFilter}
                disabled={disabled || ruleType !== rule || !newId.trim()}
              >
                +
              </button>
            </div>
          </div>

          {ids.length > 0 && (
            <div className="d-flex flex-wrap gap-2">
              {ids.map((id) => (
                <span
                  key={id}
                  className="badge bg-primary d-flex align-items-center"
                >
                  {id}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: '10px' }}
                    onClick={() => handleRemoveId(ruleType, id)}
                    disabled={disabled}
                  />
                </span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
